// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getRutas as listRutasAPI,
    getRuta as getRutaAPI,
    addRuta as addRutaAPI,
    updateRuta as updateRutaAPI,
    deleteRuta as deleteRutaAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { rutasApiResponseError, rutasApiResponseSuccess } from './actions';
import { RutasActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getRuta({ payload: { id } }) {
    try {
        const response = yield call(getRutaAPI, id );
        const rutaItem = response.data.data;
        yield put(rutasApiResponseSuccess(RutasActionTypes.GET_RUTA, rutaItem));
    } catch (error) {
        yield put(rutasApiResponseError(RutasActionTypes.GET_RUTA, error));
    }
}

function* addRuta({payload:ruta}){
    try{
        const response = yield call(addRutaAPI,{...ruta})
        const rutaItem = response.data
        yield put(rutasApiResponseSuccess(RutasActionTypes.ADD_RUTA,rutaItem))
    } catch(error){
        yield put(rutasApiResponseError(RutasActionTypes.ADD_RUTA,error))
    }
}

function* updateRuta({payload:ruta}){
    try{
        const response = yield call(updateRutaAPI,{...ruta})
        const rutaItem = response.data.data
        yield put(rutasApiResponseSuccess(RutasActionTypes.UPDATE_RUTA,rutaItem))
    }catch(error){
        yield put(rutasApiResponseError(RutasActionTypes.UPDATE_RUTA,error))
    }
}
function* deleteRuta({payload:{id}}){
    try{
        const response = yield call(deleteRutaAPI,id)
        const rutaItem = response.data.id
        yield put(rutasApiResponseSuccess(RutasActionTypes.DELETE_RUTA,rutaItem))
    }catch(error){
        yield put(rutasApiResponseError(RutasActionTypes.DELETE_RUTA,error))
    }
}

/**
 * List contactos
 */
function* listRutas({payload:params}) {
    try {
        const response = yield call(listRutasAPI, { ...params });
        const listaRutas = response.data.data;
        yield put(rutasApiResponseSuccess(RutasActionTypes.LIST_RUTAS, listaRutas));
    } catch (error) {
        yield put(rutasApiResponseError(RutasActionTypes.LIST_RUTAS, error));
    }
}


export function* watchGetRuta(): any {
    yield takeEvery(RutasActionTypes.GET_RUTA, getRuta);
}

export function* watchListRutas(): any {
    yield takeEvery(RutasActionTypes.LIST_RUTAS, listRutas);
}

export function* watchAddRuta():any{
    yield takeEvery(RutasActionTypes.ADD_RUTA,addRuta)
}
export function* watchUpdateRuta():any{
    yield takeEvery(RutasActionTypes.UPDATE_RUTA,updateRuta)
}
export function* watchDeleteRuta():any{
    yield takeEvery(RutasActionTypes.DELETE_RUTA,deleteRuta)
}


function* rutasSaga(): any {
    yield all([
        fork(watchGetRuta),
        fork(watchListRutas),
        fork(watchAddRuta),
        fork(watchUpdateRuta),
        fork(watchDeleteRuta),
    ]);
}

export default rutasSaga;
